import { render, staticRenderFns } from "./pricePloy.vue?vue&type=template&id=4a614467&scoped=true"
import script from "./pricePloy.vue?vue&type=script&lang=js"
export * from "./pricePloy.vue?vue&type=script&lang=js"
import style0 from "./pricePloy.vue?vue&type=style&index=0&id=4a614467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a614467",
  null
  
)

export default component.exports